import React from 'react'

import cn from 'classnames'
import { observer } from 'mobx-react'
import { useRouter } from 'next/router';

import { MARKET_PATHS } from '@constants/index';
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect'
import I18n from '@utils/i18n';
import { getListData } from '@widget/market/TradeList/utils'
import { ListWeb } from '@widget/news/MarketListWeb';

import { store } from '../../../store/index'

import styles from './index.module.less'

export const Market = observer(() => {
  const router = useRouter()

  const getHotCoinsData = () => {
    const dataSource = getListData('USDT', store.marketStore)
    return dataSource.slice(0, 5);
  }

  const clickMore = () => {
    router.push({
      pathname: MARKET_PATHS.MARKET
    })
  }

  useIsomorphicLayoutEffect(() => {
    async function fetchData () {
      Promise.all([
        store.marketStore.fetchMarketCoin(),
        store.marketStore.fullMarketSymbols()
      ])
    }
    fetchData()
  }, [])

  return <div className={styles.container}>
      <div className={styles.headerContainer}><h2 className={cn(styles.h2, 'Medium')}>{I18n.t('home_market')}</h2>
      <span data-buried="more" className={styles.moreBtn} onClick={clickMore}>{I18n.t('more')}</span>
      </div>
      <ListWeb
        dataSource={getHotCoinsData()}
        page='HOME_HOT'
        dataBuried='ZX-05'
      />
  </div>
})
